var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7.84651 6.43233L6.4323 7.84654L5.01808 6.43233L-2.86102e-05 1.41421L1.41418 0L6.4323 5.01811L11.4504 0L12.8646 1.41421L7.84651 6.43233Z","fill":"#4A4A4A"}));
}

ArrowDown.defaultProps = {"width":"13","height":"8","viewBox":"0 0 13 8","fill":"none"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
